import { useState } from 'react';
import '../../styles/Login.css';
import { useDispatch } from 'react-redux';
import { clearLoginError, resetPassword } from '../../redux/actions/user.action';

function ModalForgotPassword({ setShowResetForm, setError, error, email, setEmail, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();
  // состояние для отображения  подтверждения
  const [addSuccess, setAddSuccess] = useState(false);
  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  const handleSubmit = async () => {
    if (!isValidEmail(email)) {
      setError(t?.invalidEmail || 'Введите корректный email');
      return;
    }
    setError('');
    const response = await dispatch(resetPassword({ username: email }));
    if (response) {
      setAddSuccess(true);
    }
  };

  return (
    <>
      {addSuccess && (
        <div className="centered-container">
          <h5 className="success-info m-0 centered-message">
            {t?.resetSuccessMessage || ' Инструкция для сброса пароля отправлена на указанную почту.'}
          </h5>

          <div className="button-container">
            <button className="full-width-btn add-button w-100 btn-success" onClick={() => setShowResetForm(false)}>
              {t?.closeButton || 'Закрыть'}
            </button>
          </div>
        </div>
      )}
      {!addSuccess && (
        <>
          <div className="h-100 w-75 mb-auto d-flex flex-column flex-grow-1">
            <label className={email ? 'visible' : 'hidden'} htmlFor="email">
              {t?.emailLabel || 'Почта'}
            </label>
            <input
              id="email"
              type="text"
              className={`login-input w-100 ${error ? 'login-input-error' : ''}`}
              name="email"
              placeholder={t?.emailPlaceholder || 'Введите почту'}
              value={email || ''}
              onChange={(event) => setEmail(event.target.value)}
              onFocus={() => error && setError('')}
              required
              autoFocus
              autoComplete="off"
            />
            {/* Пустой div для заполнения пространства */}
            <div className="flex-grow-1"></div>

            <div className="mt-auto">
              <button
                className={`add-button w-100 ${email && !error ? 'btn-success' : ''}`}
                onClick={handleSubmit}
                disabled={!email || error}
              >
                {t?.resetPasswordButton || 'Сбросить пароль'}
              </button>
              <button
                className="forgot-button"
                onClick={() => {
                  setError('');
                  setShowResetForm(false);
                  dispatch(clearLoginError());
                }}
              >
                {t?.loginButton || 'Войти'}
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ModalForgotPassword;
